// extracted by mini-css-extract-plugin
export default {"ljiRed":"#ee2346","noTransitionProjects":"TransitionProjectList_noTransitionProjects__GJqNo","editLink":"TransitionProjectList_editLink__+aEoo"};